import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { TileButton } from './TileButton';

const SuggestedQuestions = forwardRef(({
  questions,
  onClick,
  drawerState,
  withAskPrompt,
  handleAskPromptClick,
  truncate
}, ref) => {
  const questionClasses = useMemo(() => classNames(
    'sui-flex sui-gap-4 sui-content-stretch sui-mb-4 sui-mt-2 sui-items-start',
    drawerState !== 'OPEN' ? 'sui-flex-row sui-overflow-x-scroll' : 'sui-flex-col'
  ), [drawerState]);

  if (!questions?.length) return null;

  const askPrompt = 'Ask a question';

  return (
    <div className={questionClasses} data-testid="suggested-questions" ref={ref}>
      {withAskPrompt && (
        <div className="sui-flex sui-shrink-0 sui-grow" key="ask-prompt">
          <TileButton
            onClick={handleAskPromptClick}
            value={askPrompt}
            data-testid="suggested-question"
            truncate={truncate}
          />
        </div>
      )}
      {questions.map((question, i) => ([
        <div className="sui-flex sui-shrink-0 sui-grow" key={i}>
          <TileButton
            onClick={() => onClick(question)}
            value={question}
            data-testid="suggested-question"
            truncate={truncate}
            withIcon
          />
        </div>
      ]))}
    </div>
  );
});

SuggestedQuestions.propTypes = {
  withAskPrompt: PropTypes.bool,
  questions: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func.isRequired,
  drawerState: PropTypes.string.isRequired,
  handleAskPromptClick: PropTypes.func,
  truncate: PropTypes.bool,
};

SuggestedQuestions.defaultProps = {
  withAskPrompt: false,
  questions: [],
  handleAskPromptClick: () => {},
  truncate: false,
};

export { SuggestedQuestions };
